// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","list_item":"yxhF9D","AniFadeIn":"RGmyFd","AniFadeOut":"zNtwj1","AniRotate":"rMjumq","AniPlaceholderFadeOut":"_2o3rt0"};